(function ($) {
  "use strict";
  $(function () {
    $('[data-entity="vacancy-link"]').on('click', function (e) {
      if (typeof window.reachMetricsGoal === typeof Function){
        window.reachMetricsGoal('vacancy');
      }
      e.preventDefault();
      e.stopPropagation();
      window.open($(this).data('url'), '_blank');
    });
  });

})(jQuery);



